import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
import { getRealizeValue, isArrayNotEmpty } from '@/common/util/util';
import { handleResultProcessFunc, transRequestConfigToRemote, } from '@/common/util/request';
export const config = {
    value: 'loadDynamicFormConfig',
    position: ALL_BUTTON_POSITION_LIST,
    action: async (config) => {
        const { buttonConfig, urlParamsDataSource, state, _context, formRef, recordDataSource, isDesign, } = config || {};
        const { options } = buttonConfig || {};
        const { requestConfig, _bindForm } = options || {};
        const realFormRef = getRealizeValue(formRef);
        if (requestConfig?.url) {
            // eslint-disable-next-line no-inner-declarations
            async function reloadFormSchemaByRequestConfig(ref) {
                const _requestConfig = transRequestConfigToRemote({
                    requestConfig,
                    state,
                    urlParamsDataSource,
                    recordDataSource: getRealizeValue(recordDataSource),
                    isDesign,
                });
                const formatResult = handleResultProcessFunc(requestConfig);
                if (typeof formatResult === 'function') {
                    _requestConfig.formatResult = formatResult;
                }
                /** 调用源码组件reLoad方法，reLoad方法借助requestConfig请求获取新的schema */
                try {
                    await ref?.reLoad?.(_requestConfig);
                }
                catch (err) {
                    console.error('reload error', err);
                }
            }
            if (realFormRef) {
                await reloadFormSchemaByRequestConfig(realFormRef);
            }
            else if (isArrayNotEmpty(_bindForm)) {
                // _bindForm 为业务在低码中的配置
                for (const id of _bindForm) {
                    if (typeof id === 'string' && id) {
                        const form = _context?.$(id);
                        if (form) {
                            const tempFormRef = form.getFormRef?.();
                            // eslint-disable-next-line no-await-in-loop
                            await reloadFormSchemaByRequestConfig(tempFormRef);
                            // 重新请求表单 schema 后，重新渲染表单
                            form.reRender();
                        }
                    }
                }
            }
        }
    },
};
